import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const GET_PROMOTION_LIST = "/api/getPromotionList";//获取满减活动列表
const GET_PROMOTION_DETAIL = "/api/getPromotionDetail";//获取满减活动详情
const DELETE_PROMOTION = "/api/deletePromotion";//删除优惠活动
const SAVE_PROMOTION = "/api/savePromotion";//保存活动

export default {
	getPromotionList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_PROMOTION_LIST, params);
			commit('GET_PROMOTION_LIST', data);
		}catch(e){
			throw e
		}
	},
	
	getPromotionDetail: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_PROMOTION_DETAIL, params);
			commit('GET_PROMOTION_DETAIL', data);
		}catch(e){
			throw e
		}
	},
	
	deletePromotion: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.post(DELETE_PROMOTION, params);
		}catch(e){
			throw e
		}
	},
	
	savePromotion: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(SAVE_PROMOTION, params);
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/marketing/promotions/actions.js